"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    chipWrapper: {
      '& > *': {
        margin: theme.spacing(0.5)
      }
    },
    inputWrapper: {
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(0.5)
      }
    }
  };
});

var ProductKeywords = function ProductKeywords(_ref) {
  var keywords = _ref.keywords,
      lang = _ref.lang,
      onChangeLang = _ref.onChangeLang,
      onAddKeyword = _ref.onAddKeyword,
      onRemoveKeyword = _ref.onRemoveKeyword;
  var classes = useStyles();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      newKeyword = _useState2[0],
      setNewKeyword = _useState2[1];

  var onSubmit = function onSubmit() {
    var _k = newKeyword.trim();

    if (_k.length > 0) {
      onAddKeyword(newKeyword, lang);
    }

    setNewKeyword('');
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
    color: "secondary",
    value: lang,
    fullWidth: true,
    onChange: function onChange(_, v) {
      return onChangeLang(v);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    value: "nl",
    label: "NL"
  }), /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    value: "fr",
    label: "FR"
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: 2,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    className: classes.chipWrapper
  }, keywords.map(function (keyword) {
    return /*#__PURE__*/_react["default"].createElement(_core.Chip, {
      onDelete: function onDelete() {
        return onRemoveKeyword(keyword, lang);
      },
      label: keyword,
      variant: "outlined"
    });
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: 2,
    display: "flex",
    flexDirection: "row",
    className: classes.inputWrapper
  }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    fullWidth: true,
    variant: "outlined",
    onChange: function onChange(event) {
      return setNewKeyword(event.target.value);
    },
    onKeyUp: function onKeyUp(event) {
      if (event.keyCode === 13) {
        onSubmit();
      }
    },
    value: newKeyword
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    color: "primary",
    variant: "outlined",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Add["default"], null),
    onClick: onSubmit
  }, "Add")));
};

var _default = ProductKeywords;
exports["default"] = _default;